import { render, staticRenderFns } from "./DualRings.vue?vue&type=template&id=1d64a633&scoped=true&"
import script from "./DualRings.vue?vue&type=script&lang=js&"
export * from "./DualRings.vue?vue&type=script&lang=js&"
import style0 from "./DualRings.vue?vue&type=style&index=0&id=1d64a633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64a633",
  null
  
)

export default component.exports